import { IGetters } from './getters.types'
import { IMigrationImport} from '@/entities'
import { AppConstants as _app } from '@/shared/app.constants';
import {Utilities as _utils} from '@/shared/utilities';

export const getters: IGetters = {
    indicators(state: IMigrationImport): any {
        return state.Indicators;
    },
    migrationId(state: IMigrationImport): any {
        return state.MigrationImportId;
    },
    rootTemplate(state: IMigrationImport): any
    {
        return state.Schema;
    },
    currency(state: IMigrationImport)
    {
        return state.Currency;
    }
}